import PropTypes from "prop-types";
import React from "react";
import { useDispatch } from "react-redux";

import { ChatDropzoneContainer } from "./ChatDropzone.style";
import FilesSection from "../album/filesSection/FilesSection.component";
import { setTempFileAsSelected } from "../../redux/multimediaDuck";
import CONSTANTS from "../../const/constants";
import { fileTypes, onDrop } from "../../utils/multimedia";

const ChatDropzone = ({
  fileType,
  templateMedia,
  isPreview,
  newTheme,
  isSelectTemplate,
}) => {
  const dispatch = useDispatch();

  const handleDrop = async (acceptedFiles) => {
    await onDrop(acceptedFiles, dispatch);
  };
  // const onDrop = async (acceptedFiles) => {
  //   console.log("acceptedFiles => ", acceptedFiles);
  //   if (acceptedFiles && acceptedFiles.length === 1) {

  //     const file = acceptedFiles[0];
  //     const url = await URL.createObjectURL(file);
  //     const tempFile = [
  //       {
  //         id: CONSTANTS.UPLOAD_ID,
  //         file,
  //         url,
  //         fileType: file.name.split(".").pop(),
  //         fileName: file.name,
  //         mimeType: file.type,
  //         weight: file.size,
  //       },
  //     ];
  //     console.log("tempFile => ", tempFile);
  //     dispatch(setTempFileAsSelected(tempFile));
  //   } else if (acceptedFiles && acceptedFiles.length > 1) {
  //     console.log("acceptedFiles => ", acceptedFiles);
  //     const files = acceptedFiles.map((file) => {
  //       return {
  //         id: CONSTANTS.UPLOAD_ID,
  //         file,
  //         url: URL.createObjectURL(file),
  //         fileType: file.name.split(".").pop(),
  //         fileName: file.name,
  //         mimeType: file.type,
  //         weight: file.size,
  //       };
  //     });
  //     dispatch(setTempFileAsSelected(files));
  //   }
  // };

  const mainLabel = (constFileType) => {
    switch (constFileType) {
      case CONSTANTS.FILE_TYPE_IMAGE:
        return "filesDropZoneMainImageText";
      case CONSTANTS.FILE_TYPE_PDF:
        return "filesDropZoneMainTextPdf";
      case CONSTANTS.FILE_TYPE_VIDEO:
        return "filesDropZoneMainVideoText";
      case CONSTANTS.FILE_TYPE_TEMPLATE:
        return "filesDropZoneMainTemplateText";
      default:
        return "filesDropZoneMainText";
    }
  };

  return (
    <ChatDropzoneContainer newTheme={newTheme}>
      <FilesSection
        hideTitle
        onDrop={handleDrop}
        maxSize={templateMedia ? undefined : 16777216}
        sizeLabel={
          templateMedia ? undefined : "filesDropZoneChatSizeText"
        }
        prepareFiles={() => null}
        acceptedFilesTypes={fileTypes(fileType)}
        mainLabel={mainLabel(fileType)}
        canUploadFiles
        templateMedia={templateMedia}
        isPreview={isPreview}
        newTheme={newTheme}
        isSelectTemplate={isSelectTemplate}
        allowPlainText={!templateMedia}
      />
    </ChatDropzoneContainer>
  );
};

ChatDropzone.propTypes = {
  fileType: PropTypes.string,
};

export default ChatDropzone;
